import React from 'react'
import { Route } from 'react-router-dom'

import withAuth from './withAuth'

const ProtectedAuthRoute = props => <Route {...props} />

export default withAuth(ProtectedAuthRoute)



// WEBPACK FOOTER //
// ./src/components/templates/route-management/ProtectedAuthRoute.js